import { render, staticRenderFns } from "./user-beauty-tags.vue?vue&type=template&id=57d3ee6e&scoped=true"
import script from "./user-beauty-tags.vue?vue&type=script&lang=js"
export * from "./user-beauty-tags.vue?vue&type=script&lang=js"
import style0 from "./user-beauty-tags.vue?vue&type=style&index=0&id=57d3ee6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3ee6e",
  null
  
)

export default component.exports